export const APP_SCROLL_CONTAINER_ID = "app-scroll-container";

export function smoothScrollToTop() {
    const container = document.getElementById(APP_SCROLL_CONTAINER_ID);
    if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
        return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
}

export const scroll = {
    smoothScrollToTop,
};
